import React, {Component} from "react";
import Api from "../Api";
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import $ from "jquery";

export default class NewsItemPreview extends Component {
    onChangePageAnimation(e, url) {
        // e.preventDefault();
        $('html,body').scrollTop(0);
        // this.setState({redirect: url});
    }

    render() {
        const item = this.props.item;

        return <div className={`col-xs-12 news__item ${this.props.left ? ' even' : ' odd'}`}>
            <Link className="news__item__content u-relative" to={`/news/${item.alias}`} onClick={(e) => this.onChangePageAnimation(e)}>
                <div className="news__cover u-relative">
                    <img data-src={Api.getImage(item.image)} alt={item.title} className="news__image lazyload"/>
                </div>
                <div className="news__desc u-relative">
                    <div className="news__date">{item.datetime}</div>
                    <h3 className="news__title u-bold">{item.title}</h3>
                    <span className="news__btn u-absolute">
                        <span className="u-block u-absolute u-overflow-h slider-arrow__base">
                            <span className="slider-arrow__circle u-absolute u-pos-tl u-fit u-block u-overflow-h"/>
                        </span>
                        <span className="slider-arrow__inner u-pos-tl u-absolute u-fit u-block">
                            <span className="slider-arrow__icon u-absolute u-overflow-h u-block">
                                <span className="slider-arrow__bar u-absolute u-inline-block"/>
                                <svg className="slider-arrow__triangle u-absolute u-block u-pos-tl">
                                    <use xlinkHref="/static/media/svg-symbols.svg#triangle-right"/>
                                </svg>
                            </span>
                        </span>
                    </span>
                </div>
            </Link>
        </div>
    }
}

NewsItemPreview.propTypes = {
    item: PropTypes.any.isRequired,
    left: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/js/components/NewsItemPreview.js